/** Bundled FLUX preset previews: /makeup-v3-preset-thumbs/{presetId}.jpg (female model). */

import manifest from '../data/makeupV3PresetThumbManifest.json';

const KNOWN = new Set(manifest?.preset_ids || []);

export function makeupV3PresetThumbUrl(presetId) {
  const id = String(presetId || '').trim();
  if (!id || !KNOWN.has(id)) return '';
  const ver = manifest?.asset_version;
  const q = ver ? `?v=${encodeURIComponent(ver)}` : '';
  return `/makeup-v3-preset-thumbs/${id}.jpg${q}`;
}

export function makeupV3PresetHasThumb(presetId) {
  return KNOWN.has(String(presetId || '').trim());
}
